import * as React from 'react'

import { SCREENS } from './workflow'

import useReducer from '@store/useReducer'
import * as AuthStore from '@store/auth/auth'
import { AuthScope, ControleQualiteNature } from '@api/enum'

const init = Object.keys(SCREENS) as ControleStep[]

interface Options {
  manifestationId?: string
}

const useWorkflow = (form: ControleForm, user: UserResponse, options: Options) => {
  const scopes = useReducer(AuthStore.store, (s) => s.scopes)

  const [workflow, setWorkflow] = React.useState(init)
  const [starter, setStarter] = React.useState<Partial<ControleForm>>({})

  React.useEffect(() => {
    const next = init

    // add rules on workflow
    // every rule defined workflow cut

    // *************************************************
    //                  context rules
    // *************************************************

    const UserPrestataireRule: ControleStep[] =
      scopes.includes(AuthScope.ControleQualitePrestataireCreation) && user.societeId ? ['presta', 'type'] : []

    // *************************************************
    //                  options rules
    // *************************************************

    const ManifestationOptionRule: ControleStep[] = options.manifestationId ? ['nature', 'manif'] : []

    // *************************************************
    //                  content rules
    // *************************************************

    const MaintenanceRule: ControleStep[] = form.nature === 'MAINTENANCE' ? ['manif', 'period'] : []

    const wf = next
      .filter((s) => !UserPrestataireRule.includes(s))
      .filter((s) => !ManifestationOptionRule.includes(s))
      .filter((s) => !MaintenanceRule.includes(s))

    setWorkflow(wf)
  }, [form.nature, user, options.manifestationId])

  React.useEffect(() => {
    // add rules on workflow
    // every rule defined starter add

    // *************************************************
    //                  context rules
    // *************************************************

    const UserPrestataireRule: Partial<ControleForm> =
      scopes.includes(AuthScope.ControleQualitePrestataireCreation) && user.societeId
        ? { societeId: user.societeId }
        : {}

    // *************************************************
    //                  options rules
    // *************************************************

    const ManifestationOptionRule: Partial<ControleForm> = options.manifestationId
      ? { nature: ControleQualiteNature.PRESTATION, manifestationId: options.manifestationId }
      : {}

    setStarter({ ...UserPrestataireRule, ...ManifestationOptionRule })
  }, [user, options.manifestationId])

  return [workflow, starter] as const
}

export default useWorkflow
